import PropTypes from 'prop-types';
import ItemType from '../types/item';
import { CartTypes } from '../reducers/cartReducer';

function CartRow({ cartItem, items, dispatch }) {
  const item = items.find((i) => i.itemId === cartItem.itemId);
  const removeCart = () => {
    dispatch({ type: CartTypes.REMOVE, itemId: cartItem.itemId });
  };
  const addOne = () => {
    dispatch({ type: CartTypes.ADD, itemId: cartItem.itemId });
  };
  const subtractOne = () => {
    dispatch({ type: CartTypes.SUBTRACT, itemId: cartItem.itemId });
  };
  return (
    <tr key={item.itemId}>
      <td>{item.title}</td>
      <td>{cartItem.quantity}</td>
      <td>
        $
        {(item.salePrice ?? item.price) * cartItem.quantity}
      </td>
      <td className="cart-component-actions">
        <button type="button" onClick={removeCart}>
          X
        </button>
        <button type="button" onClick={addOne}>
          +
        </button>
        <button type="button" onClick={subtractOne}>
          -
        </button>
      </td>
    </tr>
  );
}

CartRow.propTypes = {
  cartItem: PropTypes.shape({
    itemId: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired,
  }).isRequired,
  items: PropTypes.arrayOf(ItemType).isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default CartRow;
